import { cloneElement, ReactElement } from 'react';

import { GroupBase, OptionsOrGroups } from 'react-select';

import { isNotDefined, isOfType } from '@hsp/utilities';

const flatten = <Option, Group extends GroupBase<Option>>(
  options: OptionsOrGroups<Option, Group> | undefined,
  result: (Option | Group)[] = []
) => {
  if (isNotDefined(options)) {
    return [];
  }

  for (let i = 0, length = options.length; i < length; i++) {
    const value = options[i];

    if (isOfType<GroupBase<Option>>(value, 'options')) {
      result.push(value);
      flatten(value.options, result);
    } else {
      result.push(value);
    }
  }

  return result;
};

export const calculateLength = <Option, Group extends GroupBase<Option>>(
  options: OptionsOrGroups<Option, Group> | undefined
) => {
  options = options || [];
  const first = options[0] || {};
  const isGroup = isOfType<GroupBase<Option>>(first, 'options');

  if (isGroup) {
    return options.reduce((previous, current: Option | Group) => previous + (current as Group).options.length + 1, 0);
  }

  return options.length;
};

// Disabling for now until the type can be determined
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const flattenChildren = (children: any[]) => {
  return children.reduce((result, child) => {
    const {
      props: { children: nestedChildren = [] },
    } = child;

    return [...result, cloneElement(child, { type: 'group' }, []), ...nestedChildren];
  }, [] as ReactElement[]);
};

export const flattenOptions = <Option, Group extends GroupBase<Option>>(options?: OptionsOrGroups<Option, Group>) => {
  return flatten(options);
};
